import React, { useState } from "react";

import { ViewStyle, View } from "react-native";
import NavBarButton from "../NavBar/NavBarButton";
import { IcLightBulb } from "../../utils/Icons";
import { TipIds, TipIdsByCycle } from "../../models/Tips";
import User from "../../data/user/User";
import Modal from "../../../specific/components/Modal/Modal";
import DocumentsViewer from "../Documents/DocumentsViewer";
import PDFViewer from "../../../specific/components/PDF/PDFViewer";
import { localizedString } from "../Activities/ActivitySheet";
import { getLanguage } from "../../utils/Localization/Localization";
import AppTheme from "../../utils/Theme";

interface TipsButtonProps {
    tips: TipIds;
    style?: ViewStyle;
    color?: string;
    id?: string;
}

const TipsButton = (props: TipsButtonProps) => {
    const { style, color, id, tips } = props;
    const user: User = User.getInstance();
    const appTheme: AppTheme = new AppTheme();

    const [doc, setDoc] = useState<{ id?: string; type: string; url?: localizedString; } | undefined>(undefined);

    const renderDocument = () => {
        if (doc === undefined) {
            return <View />
        }
        if (doc.type === "doc") {
            return <DocumentsViewer documentId={doc.id} onDocumentCloseRequest={() => setDoc(undefined)} />
        } else if (doc.type === "pdf") {
            return <PDFViewer pdfUrl={doc.url[getLanguage()]} color={color} title="" closeTheDocument={() => setDoc(undefined)} />
        }

    }

    const openDocument = () => {
        let docsToOpen: TipIdsByCycle = tips.all_targets;
        if (tips[user.profile] !== undefined) {
            docsToOpen = tips[user.profile];
        }
        let docToOpen: { id?: string; type: string; url?: string; } = docsToOpen.all;
        if (docsToOpen[user.children_level] !== undefined) {
            docToOpen = docsToOpen[user.children_level];
        }
        setDoc(docToOpen);
    }

    return <View>
        <NavBarButton icon={IcLightBulb} style={style} action={openDocument} />
        <Modal visible={doc !== undefined} animationType="slide" style={{ flex: 1 }}>
            <View style={{ paddingLeft:appTheme.webNavBarWidth, width: appTheme.getFullScreenWidth(), alignItems: "center", backgroundColor:"#FFFFFF80" }}>
                {renderDocument()}
            </View>
        </Modal>
    </View>
}

export default TipsButton;